import DBDisplay from './DB&Display';

export default {
  title: 'Local Database support & Display application',
  description:
    'Change the preferences regarding stored data and Customer Display.',
  path: '/pos-settings/db-display',
  component: DBDisplay,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'Local Database support & Display application' }],
};
